import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./FranchisesUIHelpers";

const FranchisesUIContext = createContext();

export function useFranchisesUIContext() {
  return useContext(FranchisesUIContext);
}

export const ProductsUIConsumer = FranchisesUIContext.Consumer;

export function FranchisesUIProvider({ productsUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    // openEditProductPage: productsUIEvents.openEditProductPage,
    // openDeleteProductDialog: productsUIEvents.openDeleteProductDialog,
    // openDeleteProductsDialog: productsUIEvents.openDeleteProductsDialog,
    // openFetchProductsDialog: productsUIEvents.openFetchProductsDialog,
    // openUpdateProductsStatusDialog:
    // productsUIEvents.openUpdateProductsStatusDialog,
  };

  return (
    <FranchisesUIContext.Provider value={value}>
      {children}
    </FranchisesUIContext.Provider>
  );
}
